import React from 'react'
import { wrapLazy } from '@startlibs/utils'
import axios from 'axios'
import _ from 'lodash/fp'

export const lazyRecords = wrapLazy((caseId, patientUID) =>
  (caseId
    ? axios.get(
        `/case/${encodeURIComponent(caseId)}?${_.toPairs(_.pickBy(Boolean, { patientUID })).join(
          '='
        )}`
      )
    : axios.get(`/record/patient/${patientUID}`)
  ).then(({ data }) => data)
)
